import "./App.css";
import { Toaster } from "react-hot-toast";
import AppRouter from "./routes/AppRouter";

function App() {
  return (
    <div data-theme="emerald">
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          className: "!rounded-xl !shadow-lg",
          error: {
            duration: 5000,
          },
        }}
      />
      <AppRouter />
    </div>
  );
}

export default App;
